import { DatePicker } from "@/shared/components/common/DatePicker/DatePicker"
import { useDateStart } from "./useDateStart"

function DateStart() {
  const { value, setValue, pickerType, setPickerType } = useDateStart();
  return (
    <DatePicker
      value={value}
      onChange={setValue}
      minDate={new Date(2024, 0, 1)}
      placeholder="Дата начала периода"
      pickerType={pickerType}
      onPickerTypeChange={setPickerType}
    />
  )
}

export default DateStart